"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _state = require("printableWorksheets/state");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _state2 = require("../../state");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _printableWorksheets = require("printableWorksheets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GradeSelector = function GradeSelector() {
  var _gradesToTitleMapper;
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    setActiveGrade = _usePrintableWorkshee.setActiveGrade,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment;
  var gradesToTitleMapper = (_gradesToTitleMapper = {}, _defineProperty(_gradesToTitleMapper, _state2.Grades.ALL_GRADES, 'All Grades'), _defineProperty(_gradesToTitleMapper, _state2.Grades.PRE_K, 'Pre-K'), _defineProperty(_gradesToTitleMapper, _state2.Grades.K, 'K'), _defineProperty(_gradesToTitleMapper, _state2.Grades.ONE, '1'), _defineProperty(_gradesToTitleMapper, _state2.Grades.TWO, '2'), _defineProperty(_gradesToTitleMapper, _state2.Grades.THREE, '3'), _defineProperty(_gradesToTitleMapper, _state2.Grades.FOUR, '4'), _defineProperty(_gradesToTitleMapper, _state2.Grades.FIVE, '5'), _gradesToTitleMapper);
  var setGradeAndFireEvent = function setGradeAndFireEvent(grade) {
    setActiveGrade(_state2.Grades[grade]);
    var props = {
      clickedOn: 'Grade Selector',
      grade: onboardingGrade,
      newTopicSelected: '',
      newGradeSelected: grade
    };
    _events["default"].interactedPrintablesFilters(props);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grade-selector",
    "data-sentry-component": "GradeSelector",
    "data-sentry-source-file": "gradeSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "heading"
  }, "Grade"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grades-container"
  }, Object.keys(_state2.Grades).filter(function (grade) {
    if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      if (_state2.Grades[grade] == _state2.Grades.PRE_K) return false;else return true;
    } else {
      return true;
    }
  }).map(function (grade, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: grade + index,
      onClick: function onClick() {
        return setGradeAndFireEvent(grade);
      },
      className: "grade ".concat(_state2.Grades[grade] == activeGrade ? 'selected' : '')
    }, gradesToTitleMapper[_state2.Grades[grade]]);
  })));
};
var _default = GradeSelector;
exports["default"] = _default;